export const model_po_visibility = () => {
  return {
    dispatch_summary: {
      Consignor: { value: "", type: "text" },
      Consignee: { value: "", type: "text", valid: true },
      ReferenceNo: { value: "", type: "text", valid: true },
      Warehouse: { value: "", type: "text", valid: true },
      Numberpackages: { value: "", type: "text", valid: true },
      Description: { value: "", type: "text", valid: true },
      ASN: { value: "", type: "text", valid: true },
      Arrived: { value: "", type: "text", valid: true },
      Unloaded: { value: "", type: "text", valid: true },
      Finalized: { value: "", type: "text", valid: true },
      TotalWeight: { value: "", type: "text", valid: true },
      Totalvolume: { value: "", type: "text", valid: true },
    },
  };
};
